import React from "react";

import { useState } from "react";


import TitleField from "../text/TitleField";
import TextField from "../text/TextField";

// react icons
import { FaRegUser } from "react-icons/fa";
import { FaRegCheckCircle } from "react-icons/fa";

import { RiSpaceShip2Line } from "react-icons/ri";
import { PiAirplaneTakeoff } from "react-icons/pi";

import { TbChartBarPopular } from "react-icons/tb";

import { FaHandshake } from "react-icons/fa";

import "../../styles/team/Journey.css"

import { useMediaQuery } from '../../hooks/useMediaQuery';
import Reveal from '../motion/Reveal';
import { StaggerGroup, StaggerItem } from '../motion/Stagger';

const Journey = () => {

    // Mobile always shows feature cards in landscape style (icon beside
    // text) regardless of this product's own desktop orientation.
    const isMobileViewport = useMediaQuery('(max-width: 767px)');

    const JourneyData = [

        {
            title : 'How we Started',
            description  : 
                `Jean saw firsthand how outdated software made everydate operations at Auburn Bay more difficult than
                they needed to be. Around the same time, Jad experienced many of the same problmes from the client side.
                Those shared fustrations, along with engineering degreees became the starting point for NicheWare.`,
            icon  : FaRegUser,
        },

        {
            title : 'A Chance to Prove We Could Help',
            description  : 
                `Our first opportunity came through Auburn Bay, where we built the Boathouse Renter and Rentee applications 
                around the way their team actually worked. It gave us teh change to turn our ideas into software people could
                use every day.`,
            icon  : FaRegCheckCircle,
        },

        {
            title : 'Small Team. Big Advantage.',
            description  : 
                `Being a small team means the people designing and building your software are the same people
                sitting down with you to understand the problem. We can adapt quickly, communicate directly, 
                and focus on what will actually be useful.`,
            icon  : PiAirplaneTakeoff,
        },

        {
            title : 'Always Improving',
            description  : 
                `Our work does not end when the software is released. We continue working with the people who use it,
                responding to feedback, imporving existing features, and finding new ways to make their day-to-day
                work easier.`, 
            icon  : TbChartBarPopular,
        },

        {
            title : 'Lets build The Future Together',
            description  : 
                `We started NicheWare by solving a problem close to us. 
                Now we want to bring that same approach to other organizations: 
                understand how you work, find where software can help, and build something that fits.`,
            icon  : FaHandshake,
        }

    ]


    return (
        <>
            <div className="team-journey-content-container">

                <Reveal className="team-journey-titles-container">
                    <TextField
                        className="team-journey-pill-title"
                        text="OUR JOURNEY"
                        fontSize="0.75rem"
                        fontColor="#5a7a1a"
                    />
                    <TitleField
                        className="team-journey-title"
                        title="How We Started and Where We're Headed"
                    />
                </Reveal>

                <StaggerGroup as="div" className="team-journey-info-container" scroll staggerChildren={0.3} amount={0.15}>
                    {JourneyData.map((itr, index) => (

                        <StaggerItem
                            as="div"
                            className="team-journey-milestones-container"
                            duration={0.7}
                            key={index}
                        >
                            <div className="team-journey-timeline">
                                <span className="team-journey-number">
                                    {String(index + 1).padStart(2, '0')}
                                </span>
                            </div>

                            <div className="team-journey-card">
                                <div className="team-journey-card-text">
                                    <TitleField title={itr.title} bold={true}/>
                                    <TextField text={itr.description}/>
                                </div>


                                {!isMobileViewport && (
                                    <div className='team-journey-card-icon'>
                                        <itr.icon className="team-journey-icon"/>
                                    </div>
                                )}

                            </div>

                        </StaggerItem>

                    ))}
                </StaggerGroup>
            </div>

        </>
    )
};

export default Journey;